import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ColDef, Column, ColumnApi, GridApi, GridReadyEvent, PaginationChangedEvent } from 'ag-grid-community';
import { DataTable } from 'simple-datatables';
import { AlertService } from 'src/app/_services/alert.service';
import { ApiHttpService } from 'src/app/_services/api-http.service';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { environment } from 'src/environments/environment';
import { MerchantService } from '../../../merchants/merchant-master/merchant.service';
const {API_URL, defaultPageSizeArr, defaultPageSize} = environment;
@Component({
  selector: 'app-customer-report-model',
  templateUrl: './customer-report-model.component.html',
  styleUrls: ['./customer-report-model.component.scss']
})
export class CustomerReportModelComponent implements OnInit {

  @ViewChild('modalReportCustomer') private modalblockedComponent: ModalComponent;
  @Output() ScreeningReportEvent: EventEmitter<any> = new EventEmitter<any>();
  @Input() merchantStatusConfig: any;
  kycUploadModalConfig: ModalConfig;
  kycViewModalConfig: ModalConfig;
  kycFileSrc: any;
  orvreport: FormGroup;
  Resultdata: any;
  merchantId:any;
  mindatadis: boolean = true;
  loading: boolean = false;
  htmlContent: string;
  public pageSize: number = defaultPageSize;
  public pageSizeArr: any = defaultPageSizeArr;
  public page: number = 1
  currentPage: number = 1;
  public rowData:any=[];
  collectionSize: number = 0;
  collectiondata: number=0
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  tableSelectedColumn: ColDef[] = [];
  maxSize:number;
  ellipses: boolean= true;
  modalConfigBlocked: ModalConfig;
  modalConfigReport: ModalConfig;


  
  
  constructor(private  formBuilder: FormBuilder, private apiHttpService: ApiHttpService,private alertService: AlertService,private merchantService: MerchantService ) {
    this.orvreport = formBuilder.group({
      merchantId: ["", Validators.required],
      fileupload:["",Validators.required],
    })
  }
  
  ngOnInit(): void {
    const self = this;
    this. mindatadis = true;

    this.kycViewModalConfig = {
      modalTitle: "Merchant Status",
      modalSize: 'xl',
      fullscreen: true,
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      },
      onClose(): Promise<boolean> | boolean {
        self.kycFileSrc = null;
        return true
      },
      onTopClose(): Promise<boolean> | boolean {
        self.kycFileSrc = null;
        return true
      },
      onDismiss(): Promise<boolean> | boolean {
        self.kycFileSrc = null;
        return true
      }
    }
    this.modalConfigBlocked = {
      modalTitle: "Document",
      modalSize: 'xl',
   
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }
  }

  
  public columnDefs: ColDef[] = [
    {field: 'id', tooltipField: 'id', headerName: 'ID',  cellRenderer: 'agGroupCellRenderer',resizable: true,},
    {field: 'merchantId',tooltipField: 'merchantId', headerName: 'Merchant ID',resizable: true},
    {field: 'docType' ,tooltipField: 'docType', headerName: 'Doc Type',resizable: true},  
  ];



  hmnlpage:any;
   Merchantdata:any;
  onSubmit(formvalue: any): void {
    this.loading = true
    this. mindatadis = true;
     this.Merchantdata=formvalue.merchantId;
     //kyc/merge/{merchantId}
debugger
    this.apiHttpService.post(`${API_URL}/kyc/merge/${formvalue.merchantId}`, null).subscribe((data) => (
     this.downloadPdf(data,this.Merchantdata)
    ));
  }
  downloadPdf(data:any,Merchant:any) {
  //  alert("data==="+data+"  ,   Merchant======"+Merchant)
if(data){
    const linkSource =
    'data:application/octet-stream;base64,' +data.text;
    const downloadLink = document.createElement('a');
    const fileName = 'Merchant_'+Merchant+'.pdf';
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
    this.loading = false
  }else{
    this. mindatadis = false;
    this.loading = false
  }
  }
  
  downloadAutomated(){
    
    debugger
  //  let   mid=20230001;
    this.apiHttpService.post(`${API_URL}/mergeBasicReport/${this.merchantid}`, null)
    .subscribe((data) => (
     this.downloadPdfauto(data,this.merchantid)
    ));
  
  }

  downloadPdfauto(data:any,Merchant:any) {
 // alert("JSON DATA"+JSON.stringify(data))
 // alert("data"+data)
    if(data){
        const linkSource =
        'data:application/octet-stream;base64,' +data.text;
        const downloadLink = document.createElement('a');
        const fileName = 'AVR_'+Merchant+'.pdf';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        this.loading = false
      }else{
        this. mindatadis = false;
        this.loading = false
      }
      }
  downloadManual(){
   let   mid=2308829032;
    this.apiHttpService
    .post(
      `${API_URL}/merge/${this.merchantid}`, null
      )
    .subscribe((data) => (
     this.downloadPdfmanu(data,this.merchantid)
    ));
  }
  downloadPdfmanu(data:any,Merchant:any) {
    if(data){
        const linkSource =
        'data:application/octet-stream;base64,' +data.text;
        const downloadLink = document.createElement('a');
        const fileName = 'MVR_'+Merchant+'.pdf';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        this.loading = false
      }else{
        this. mindatadis = false;
        this.loading = false
      }
      }

  merchantid:any;
  disablebtn:boolean=true;
  showhtml:boolean=false
  onSelectMerchant(event:any){ 
    if(event==undefined){
      this.showhtml=false  
      this.disablebtn=true;     
    }
    else{    
      this.disablebtn=false;  
      this.merchantid=event;
      this.showhtml=true
      this.getBtnFlag(event);
     this.getDocument()
    }
  }

      getBtnFlag(merchantidd:any){
        
      }
  
  btnflag:any;
  btnpan:any
  btnvaluepan:any
  btnvalue:any;
  btnvalue1:any;
  btngst:any
  btnvaluegstn:any
  btnmca:any
  btnvaluemca:any
  btnaccount:any
  btnvalueaccount:any
  btnweb:any
  btnvalueweb:any
  btncibil:any
  btnvaluecibil:any
  btnfiu:any
  btnvaluefiu:any
  btnpep:any
  btnvaluepep:any
  btnnmas:any
  btnvaluenmas:any
  btnaml:any
  btnvalueaml:any
  osvbtn:any
  osvvalue:any
  irabtn:any
  iravalue:any
  mcmTncBtn:any
  mcmTncValue:any
  mcmMrpBtn:any
  mcmMrpValue:any
  mcmMGPbtn:any
  mcmMGPValue:any
  mcmAOCbtn:any
  mcmAOCValue:any
  mcmCOCBtn:any
  mcmCOCValue:any
  mcmVaptbtn:any
  mcmVaptValue:any



     
//   "panVerification": try,
//   "gstn": false,
//   "mca": false,
//   "accountVerification": false,
//   "webCrawler": false,
//   "cibilAndSmr": false,
//   "pepSanction": false,
//   "fiuIntegration": false,
//   "nmasVmtsMatch": false,
//   "amlVerify": false,
//   "negativeData": null,
//   "verifiedDate": null

docName:any
docpath:any
docType:any
list:any
listboolean:boolean=false;
hidehtml:boolean=true;
getDocument(){
 // alert("ts")
this.merchantService.getDocumentList(this.merchantid,this.pageSize,this.page).subscribe((data)=>{

console.log("docment list ===="+JSON.stringify(data));
  this.rowData = data?.content  || data || [],
  
 
  // this.docpath=this.rowData[0].docpath.substr(1);
  this.docpath=this.rowData[0].docpath;

this.docType=this.rowData[0].docType

if(this.docpath==''||this.docType==''){
   
  this.hidehtml=false;

}
else{
  this.hidehtml=true;
}
 
  this.collectiondata = data[0]?.totalRecord||0 
  this.collectionSize=this.collectiondata
  if(this.rowData.length <=0){
    this.alertService.errorAlertWithMessage("No records present");
    return }

})

  
}
// $scope.imageAddress='resources/img/new.png';

onPaginationChange(param: PaginationChangedEvent | any) {
  this.page=param;
  debugger
  this.gridApi.applyTransaction({remove: this.rowData})
   this.gridApi.showLoadingOverlay();
 
 
  this.getDocument();
 
}
onPageSizeChanges($event: Event) {
  debugger
  this.gridApi.paginationSetPageSize(this.pageSize)
  this.gridApi.applyTransaction({remove: this.rowData})
  this.gridApi.showLoadingOverlay();   
  this.getDocument();
}

// onGridReady(params: GridReadyEvent<IMerchantData>) {
  onGridReady(params: GridReadyEvent) {
  debugger
  this.gridApi = params.api;
  this.gridColumnApi = params.columnApi;
  this.gridApi.getFilterInstance('age', (filterParam) => {
  })
  this.gridApi.showLoadingOverlay();
  // this.gridApi.setQuickFilter(this.globalSearch);
  const allColumnIds: (string | Column)[] = [];
  params?.columnApi?.getColumns()?.forEach((column) => {
    allColumnIds.push(column.getId());
  });
  params?.columnApi?.autoSizeColumns(allColumnIds, false);
  this.getDocument();

}
image:any;
pdfvalue:boolean=false;

loadPDFFile(url: string): Promise<any> {
  console.log("url:::: "+ url);
  return new Promise((resolve, reject) => {
    this.apiHttpService.post(url, null).subscribe(
      (data) => {
 
        resolve(data.text);
      },
      (error) => {
        reject(error);
      }
    );
  });
}


async onViewBtnClick(MerchantId:any,docpath:any){

  
 
  var data=await this.loadPDFFile(`${API_URL}/getFile/${MerchantId}?location=${docpath}`);  
//   console.log("Data Loaded " + data==null)
//  console.log("stringify(data.text)==="+JSON.stringify(data))
let image_path = docpath;
  
//alert(image_path)
let file_extension = image_path.slice(-3);
  
if(file_extension==="pdf"){  
    this.pdfvalue = true;
    this.image="data:application/pdf;base64,"+data;
     console.log("inside the is pdf block:::");
    // console.log(this.image);

  
}
else{
  this.pdfvalue = false;
  this.image="data:image/png;base64,"+data;
   console.log("inside the is png block:::");
   
} 
  
this.modalblockedComponent.open(); 


 //this.image="data:application/pdf;base64,"+data.text;
 
}

 
   async loadHtmlFile() {
    debugger
    try {
      const filePath = '../../../../assets/images/merchant_summary_table.html'; // Replace with your file's path
      this.htmlContent = await this.merchantService.getHtmlFile(filePath);
    } catch (error) {
      console.error('Error loading HTML file:', error);
    }
  }


 

}
